module.exports = __webpack_public_path__ + "static/img/f1.518c3ac4.png";